import { AlertTriangle, ExternalLink, FileText, Scale, ShieldCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { FORM_EDITION } from '../../constants/formTemplate'

const AppFooter = ({ onOpenDatenschutz, onOpenImpressum, onOpenHaftungsausschluss }) => {
	const { t } = useTranslation('common')

	return (
		<footer className='app-footer'>
			<div className='app-footer-inner'>
				<div className='app-footer-card'>
					<div className='app-footer-top'>
						<div className='app-footer-brand'>
							<span className='app-footer-brand-badge'>
								<Scale size={18} />
							</span>
							<span>{t('footer.copyrightPrefix')}</span>
						</div>

						<nav className='app-footer-links'>
							<a href='https://mertens-rechtsanwalt.de' target='_blank' rel='noopener noreferrer'>
								<span className='app-footer-link-inner'>
									<ExternalLink size={14} /> {t('footer.firmWebsite')}
								</span>
							</a>
							<button onClick={onOpenDatenschutz}>
								<span className='app-footer-link-inner'>
									<ShieldCheck size={14} /> {t('footer.datenschutz')}
								</span>
							</button>
							<button onClick={onOpenImpressum}>
								<span className='app-footer-link-inner'>
									<FileText size={14} /> {t('footer.impressum')}
								</span>
							</button>
							<button onClick={onOpenHaftungsausschluss}>
								<span className='app-footer-link-inner'>
									<AlertTriangle size={14} /> {t('footer.haftungsausschluss')}
								</span>
							</button>
						</nav>
					</div>

					<div className='app-footer-bottom'>
						<span className='app-footer-copy'>
							© {new Date().getFullYear()} · {t('footer.technicalImplementation')}{' '}
							<a href='https://vt-cv-site.vercel.app' target='_blank' rel='noopener noreferrer'>
								{t('footer.authorLink')}
							</a>
						</span>

						<span className='app-footer-formularstand'>
							{t('footer.formVersion', { date: FORM_EDITION })}
						</span>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default AppFooter
